import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import * as IoIcons from "react-icons/io";
import Swal from "sweetalert2";
import { obtenerRegionales, obtenerUsuarioEducacion } from "../Services/Rest";

ReactModal.setAppElement("#root");

function EditarUsuario({ usuario, onActualizado }) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [regionales, setRegionales] = useState([]);
  const [usuarios, setUsuarios] = useState([]);

  const [formData, setFormData] = useState({
    regional: "",
    area: "",
    gestorAsignado: "",
    correoGestor: "",
    contrasena: "",
  });

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  // Cargar datos cuando abre modal
  useEffect(() => {
    const cargarDatos = async () => {
      try {
        const [resRegionales, resUsuarios] = await Promise.all([
          axios.get(obtenerRegionales, {
            auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
          }),
          axios.get(obtenerUsuarioEducacion, {
            auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
          }),
        ]);

        setRegionales(resRegionales.data);
        setUsuarios(resUsuarios.data);

        // Precargar valores actuales
        setFormData({
          regional: usuario.regional || "",
          area: usuario.area || "",
          gestorAsignado: usuario.gestorAsignado || "",
          correoGestor: usuario.correoGestor || "",
          contrasena: "",
        });
      } catch (error) {
        Swal.fire("Error", "No se pudieron cargar los datos", "error");
      }
    };

    if (modalIsOpen) {
      cargarDatos();
    }
  }, [modalIsOpen, usuario]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const postData = async (e) => {
    e.preventDefault();

    try {
      await axios.put(
        `https://educacionapi.azurewebsites.net/api/ActualizaUsuario?Id=${usuario.id}`,
        formData,
        {
          auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
        },
      );

      Swal.fire("Éxito", "Usuario actualizado correctamente", "success");

      closeModal();
      onActualizado();
    } catch (error) {
      Swal.fire("Error", "No se pudo actualizar", "error");
    }
  };

  return (
    <>
      <button className="btn btn-warning btn-sm" onClick={openModal}>
        <IoIcons.IoIosCreate />
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={{
          content: {
            maxWidth: "700px",
            margin: "auto",
            borderRadius: "15px",
            padding: "30px",
          },
        }}
      >
        <h4 className="text-center mb-4 text-primary">
          Editar Usuario #{usuario.id}
        </h4>

        <form onSubmit={postData}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label>Nombre</label>
              <input className="form-control" value={usuario.nombre} disabled />
            </div>

            <div className="col-md-6 mb-3">
              <label>Correo</label>
              <input className="form-control" value={usuario.correo} disabled />
            </div>

            <div className="col-md-6 mb-3">
              <label>Regional</label>
              <select
                name="regional"
                className="form-control"
                value={formData.regional}
                onChange={handleChange}
              >
                {regionales.map((r) => (
                  <option key={r.id || r.nombre} value={r.nombre}>
                    {r.nombre}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label>Área</label>
              <select
                name="area"
                className="form-control"
                value={formData.area}
                onChange={handleChange}
              >
                <option value="Comercial">Comercial</option>
                <option value="Educacion">Educación</option>
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label>Gestor Asignado</label>
              <select
                name="gestorAsignado"
                className="form-control"
                value={formData.gestorAsignado}
                onChange={handleChange}
              >
                {usuarios.map((u) => (
                  <option key={u.id} value={u.nombre}>
                    {u.nombre}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label>Correo Gestor</label>
              <select
                name="correoGestor"
                className="form-control"
                value={formData.correoGestor}
                onChange={handleChange}
              >
                {usuarios.map((u) => (
                  <option key={u.id} value={u.correo}>
                    {u.correo}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-12 mb-4">
              <label>Nueva Contraseña</label>
              <input
                type="password"
                name="contrasena"
                className="form-control"
                placeholder="Dejar vacío si no desea cambiarla"
                value={formData.contrasena}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="d-flex justify-content-between">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeModal}
            >
              Cancelar
            </button>

            <button type="submit" className="btn btn-primary">
              Guardar Cambios
            </button>
          </div>
        </form>
      </ReactModal>
    </>
  );
}

export default EditarUsuario;
